export enum AlertModalSign {
  Success,
  Error,
  Warning
}
